import { gql } from '@apollo/client'

export default gql(`
    mutation exportAssetsCsv($assets: [ID!], $project: String) {
        exportAssetsCsv(
            assets: $assets
            project: $project
        ) {
            status
            assets
        }
    }`
)
